import http from '@/plugins/http';
import reportError from '@/utils/reportError';
import myJobsTransformer from '../../transformers/job/jobList';

export default (filters, page) => new Promise((res, rej) => {
  const params = {};
  if (filters.id) {
    params['job_search[id]'] = filters.id;
  }

  if (filters.start) {
    params['job_search[start]'] = filters.start.format();
  }

  if (filters.end) {
    params['job_search[end]'] = filters.end.format();
  }

  if (filters.limit) {
    params['job_search[limit]'] = filters.limit;
  }

  if (filters.sort) {
    params['job_search[sort]'] = filters.sort;
  }

  if (filters.tags && filters.tags.length) {
    params['job_search[tags]'] = filters.tags;
  }

  if (filters.text) {
    params['job_search[text]'] = filters.text;
  }

  if (filters.geopool) {
    params['job_search[geo_pool]'] = filters.geopool;
  }

  if (filters.statuses) {
    params['job_search[statuses]'] = filters.statuses;
  }

  if (page) {
    params.page = page;
  }
  const requestId = 'get_my_jobs';
  http.cancel(requestId);
  http.get('/customer/me/jobs', {
    params,
    // use before callback
    requestId,
  })
    .then((response) => {
      response.data.results = myJobsTransformer.fetchCollection(response.data.results);
      res(response.data);
    })
    .catch((error) => {
      if (http.isCancel(error)) {
        window.console.error('Request canceled');
      } else {
        reportError(error, 'error trying to get my job list');
        rej(error);
      }
    });
});
